import { useToggle } from '@commenda/kakashi';
import { useState } from 'react';

const useChatRoomTabs = () => {
  const isSearchActive = useToggle(false);

  const [searchQuery, setSearchQuery] = useState<string | null>(null);

  return {
    isSearchActive,
    searchQuery,
    setSearchQuery,
  };
};

export { useChatRoomTabs };
